import { SxProps, Theme } from '@mui/material';

const AUTOCOMPLETE_INPUT_SX: SxProps<Theme> = {
  '& input': {
    maxHeight: '16px !important',
  },
};

export const mergeAutocompleteInputSx = (sx?: SxProps<Theme>): SxProps<Theme> => {
  if (!sx) return AUTOCOMPLETE_INPUT_SX;
  if (Array.isArray(sx)) return [...sx, AUTOCOMPLETE_INPUT_SX] as SxProps<Theme>;
  return [sx, AUTOCOMPLETE_INPUT_SX] as SxProps<Theme>;
};
